exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-19d72bc6] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.my-content[data-v-19d72bc6] {\r\n    background: #fde2e2;\n}\n.pdfPriview[data-v-19d72bc6] {\r\n    height: 100%;\r\n    overflow: hidden;\n}\r\n", ""]);

// exports
